import { UnleashClient } from "@unleash/proxy-client-react";
import { addError } from "@jsq/observability";
import { environments } from "../constants";
import { identifyEnvironment } from "../identifyEnvironment";

export function getUnleashClient(applicationName: string) {
  const { environmentType, environmentKey, apiToken, apiUrl } = identifyEnvironment();

  if (environmentType === environments.unknown) {
    addError("Unable to identify environment type for unleash");
    return undefined;
  }
  if (apiToken === undefined) {
    addError(
      `Unable to identify Unleash clientToken for environment ${environmentType} and key ${environmentKey}`,
    );
    return undefined;
  }

  if (apiUrl === undefined) {
    addError(
      `Unable to identify Unleash apiUrl for environment ${environmentType} and key ${environmentKey}`,
    );
    return undefined;
  }

  const flagsClient = new UnleashClient({
    url: apiUrl,
    clientKey: apiToken,
    appName: applicationName,
    // this maps to the environment CONTEXT in Unleash.
    // Unleash also has separate a concept of environments but we don't really use them.
    // Those environments are dictated by the clientKey used.
    environment: environmentKey ?? environmentType,
    // default is 30s, which is too frequent
    refreshInterval: 300,
    // default is 60s, which is too frequent
    metricsInterval: 300,
    // default is to send a request after 2s
    metricsIntervalInitial: 15,
  });
  return flagsClient;
}
